import { SxProps } from "@mui/system";

export const errorTypography: SxProps = {
    textAlign: "center",
    color: "#d32f2f",
    fontSize: "0.8rem",
    m: "-20px auto 20px auto",
};